import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback } from 'react';
import { WebLink } from '@/components/functional/Link/WebLink/WebLink';
import { TopThemeSliderItemBase } from '@/components/modules/pages/top/slider/TopThemeSlider/TopThemeSliderItemBase';
import { isNotEmptyNumber } from '@/utils/checkValue/number';
/**
 * TOP: 相談できるテーマ スライダー（1行）の項目
 * @param props
 * @returns
 */
export const TopThemeSliderItem = (props) => {
    const { className = '', image, isActive = false, linkTo, onClickItem, text, value, } = props;
    const onClick = useCallback(() => {
        if (isNotEmptyNumber(value) && onClickItem) {
            onClickItem(value);
        }
    }, [onClickItem, value]);
    const baseProps = { image, isActive, text };
    return (_jsx("div", Object.assign({ className: clsx('px-[6px] md:px-16 py-[6px]', className) }, { children: linkTo ? (_jsx(WebLink, Object.assign({ className: 'group', target: '_blank', to: linkTo }, { children: _jsx(TopThemeSliderItemBase, Object.assign({}, baseProps)) }))) : (_jsx("button", Object.assign({ className: 'group', onClick: onClick, type: 'button' }, { children: _jsx(TopThemeSliderItemBase, Object.assign({}, baseProps)) }))) })));
};
